import * as React from "react";
import { useLocalObservable } from "mobx-react-lite";
import WorkbenchStore from "./WorkbenchStore";
import { ErrorStore, ProjectsStore, useStore } from "../../common/stores";
import WorkbenchService from "../services/WorkbenchService";
import TaskService from "../../tasks/services/TaskService";

function createStore(projectsStore: ProjectsStore, errorStore: ErrorStore) {
    const wbService = new WorkbenchService();
    const tasksService = new TaskService();
    const workbenchStore = new WorkbenchStore(
        errorStore,
        projectsStore,
        wbService,
        tasksService,
    );

    return {
        workbenchStore,
    };
}

const storeContext = React.createContext<ReturnType<typeof createStore> | null>(
    null,
);
type Props = {
    children: React.ReactNode;
};

export const WorkbenchStoreProvider: React.FC<Props> = ({ children }) => {
    const root = useStore();

    const store = useLocalObservable(() =>
        createStore(root.projectsStore, root.errorStore),
    );
    return (
        <storeContext.Provider value={store}>{children}</storeContext.Provider>
    );
};

export const useWorkbenchStore = () => {
    const store = React.useContext(storeContext);
    if (!store) {
        // this is especially useful in TypeScript so you don't need to be checking for null all the time
        throw new Error(
            "useWorkbenchStore must be used within WorkbenchStoreProvider",
        );
    }

    return store;
};
